"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
Date.prototype.isValid = (date) => !isNaN(Date.parse(String(date)));
